<div class="container width100 card">
    <p class="text-center">
        <br/>
        Thank you for completing the accelerator survey.
    </p>
    <p class="text-center">
        Please check your e-mail inbox for the survey confirmation.
        <br/>
    </p>
</div>
